import { useState, useEffect, useCallback } from "react";
import { CommonAxiosGet } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";

export const useRusaMasterData = () => {
    const [worksList, setWorksList] = useState({ new: [], renov: [], equi: [], soft: [] });
    const [phase, setPhase] = useState([]);
    const [reportdata, setReportdata] = useState([]);

    const GetWorksList = useCallback(() => {
        const url = `${config.url.API_URL}getWorksList`;
        CommonAxiosGet(url)
            .then((res) => {
                if (res?.data?.status && res?.data?.scode === "01") {
                    setWorksList({
                        new: res.data.new || [],
                        renov: res.data.renov || [],
                        equi: res.data.equi || [],
                        soft: res.data.soft || [],
                    });
                } else {
                    setWorksList({});
                }
            })
            .catch(console.error);
    }, []);

    const GetScheme = useCallback(() => {
        const url = `${config.url.API_URL}getPhase`;
        CommonAxiosGet(url).then((res) => {
            setPhase(res?.data?.scode === "01" ? res.data.phase : []);
        });
    }, []);

    const GetReportData = useCallback(() => {
        const url = `${config.url.API_URL}getSchemeCompDetails`;
        CommonAxiosGet(url).then((res) => {
            setReportdata(res?.data?.scode === "01" ? res.data.data : []);
        });
    }, []);

    useEffect(() => {

        GetWorksList();
        GetScheme();
        GetReportData();
    }, [GetWorksList, GetScheme, GetReportData]);

    return { worksList, phase, reportdata, GetReportData };
};
